import { FormInput, Grid } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Partner"
      description="Typ hieronder uw Voornaam en Naam van partner (indien correct druk op 'volgende')"
      backwardStep={(data) => {
        return data['burgerlijke_staat'] !== 'Gehuwd' ? 2 : 1;
      }}
    >
      <Grid container spacing={4}>
        <FormInput
          name="partner_voornaam"
          label="Voornaam"
          placeholder="Vul de voornaam van uw partner in"
          xs={12}
          sm={6}
          required
        />
        <FormInput
          name="partner_naam"
          label="Naam"
          placeholder="Vul de achternaam van uw partner in"
          xs={12}
          sm={6}
          required
        />
      </Grid>
    </StepWrapper>
  );
}
